export const STEPS = [
  {
    title: 'Accept the lead',
    description: 'This is the first step! By accepting the lead you will then be able to freely message the client and see their contact details.'
  },
  {
    title: 'Message the client',
    description: 'Simply use the Message tool (this page!) to confirm all details with the client. Prefer to use email or call? No problem! See the contact details just above.'
  },
  {
    title: 'Send a proposal with payment link.',
    description: 'Once you have confirmed all the details, send through a Proposal with a payment link. If you need to adjust the details simply edit the proposal.'
  },
]
